// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoBreakout_root__qoPgi","light":"VideoBreakout_light__Y51LE","video":"VideoBreakout_video__lOHlw","contentWrapper":"VideoBreakout_contentWrapper___kNSj"};